import { RegionPolicyConfig } from './types'

export const DEFAULT_REGION_POLICIES: RegionPolicyConfig[] = [
  {
    policy_key: 'privacy',
    required: true,
    policy_revision: '2026-04-21',
  },
]
